// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__DuVp0","tab":"Tabs_tab__3NdD1","tabActive":"Tabs_tabActive__VqgKA"};